<template>
  <div class="container page-global">
    <section class="content">
      <terms
        productName="iCare"
        productWebsites="icare.cafe, icare.team, ipos.cafe, api.icare.cafe, and display.dog"
        productNames="iCare, iPOS, iCare Teams, and Display Dog"
        companyName="Newcare International, LLC"
        companyShortName="Newcare"
        contractOrigin="state of Mississippi"
        contractCountry="United States of America"
      />
    </section>
  </div>
</template>

<script>
import Terms from "../components/tos/TermsOfUse.vue";

export default {
  name: "TOU",
  components: {
    terms: Terms,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/app.scss';

.content {
  padding: 4rem 0;
  text-align: left;
}
</style>